import { Component } from "react";
import { parseString } from "xml2js";

class RssFeed extends Component {
    constructor() {
      super();
      this.state = {
        recentBlogPost: {
          name: '',
          url: ''
        }
      }
    }
  
    FetchDataFromRssFeed() {
      var request = new XMLHttpRequest();
      const corsProxy = "https://cors.eu.org/"
      request.onreadystatechange = () => {
        if (request.readyState == 4 && request.status == 200) {
            console.log(request)
          var myObj = JSON.parse(request.responseText);
          for (var i = 0; i < 1; i ++) {
            this.setState({
              recentBlogPost: {
                name: myObj.items[i].title,
                url: myObj.items[i].link
              }
            });
          }
        }
      }
      //request.open("GET", "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fblog.codecarrot.net%2Ffeed.xml&order_dir=desc&count=30", true);
      request.open("GET",corsProxy + 'https://medium.com/feed/@will-carter', true);
      request.setRequestHeader('Access-Control-Allow-Origin', '*')
      request.send();
    }
  
    componentDidMount() {
      {this.FetchDataFromRssFeed()}
    }

    handleEntriesMerge = data => {
        console.info("handleEntriesMerge::data->", data)
    } 
  
    FetchDataFromRssFeed2(url) {
        const corsProxy = "https://cors.eu.org/";
        console.log(`fetch(${corsProxy} + ${url})`)
        fetch(corsProxy + url)
            .then((res) => res.text()
            .then((data) => {parseString(data, (err, res) => this.parseStringCallback(err, res, this.handleEntriesMerge))}))
            .catch((err) => console.warn("data err", err))
            .finally(() => console.info("data complete"))
    }
  
    parseStringCallback = (err, res, callback) => {
        if (err) {
          console.warn("err", err);
        } else {
          //const entries = res.feed.entry.map((item) => {
            console.info("res.rss flow", res.rss);
            const entries = res.rss.channel[0].item.map((item) => {
            return this.cleanParsedXMLEntry(item);
            });
            console.info("entries", entries);
            callback(entries);
        }
    };

    cleanParsedXMLEntry = (entry) => {
        console.log("entry->", entry)
        return{
            creator:entry["dc:creator"],
            date:entry["dc:date"],
            subject:entry["dc:subject"],
            description:entry["description"],
            title:entry.title[0],
            link:entry.link[0]
        }
        
        const media = entry["media:group"][0];
        return {
          author: entry.author[0].name[0],
          id: entry["yt:videoId"][0],
          link: entry.link[0].$.href,
          name: entry.title[0],
          publishDate: entry.published[0],
          thumbnailUrl: media["media:thumbnail"][0].$.url,
        };
      };
      
    componentDidMount() {
      //{this.FetchDataFromRssFeed()}
      //{this.FetchDataFromRssFeed2('https://medium.com/feed/@will-carter')}
      {this.FetchDataFromRssFeed2('https://www.tendancehotellerie.fr/spip.php?page=backend')}
    }
  
    render() {
      return (
        <div>
          Check out our blog: <a target="_blank" href={this.state.recentBlogPost.url}>{this.state.recentBlogPost.name}</a>
        </div>
      );
    }
  }
  
  export default RssFeed;